import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHelperService } from '../../utilities/http-helper/http-helper.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(
    private http: HttpClient,
    private httpHelper: HttpHelperService
  ) { }

  getLocationList(clientId): Observable<any> {
    let param = new HttpParams()
    .set('ClientId', clientId)
    const apiUrl = this.httpHelper.getApiUrl(`api/Locations/GetLocationName`);
    return this.http.get(apiUrl, {params: param});
  }

  getCountryList(): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl(`api/Locations/GetCountriesList`);
    return this.http.get(apiUrl);
  }

  getStateList(country): Observable<any> {
    let param = new HttpParams()
    .set('CountryName', country)
    const apiUrl = this.httpHelper.getApiUrl(`api/Locations/GetCountriesById`);
    return this.http.get(apiUrl, {params: param});
  }

  createLocation(data): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/Locations/CreateLocations`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }

  getTimezone(paramsReq): Observable<any> {
    let param = new HttpParams()
    .set('State', paramsReq.State)
    const apiUrl = this.httpHelper.getApiUrl(`api/Locations/GetTimeZoneByState`);
    return this.http.get(apiUrl, {params: param});
  }
}
